import { QueryHandler } from '../../../../_base/actionBus/QueryHandler';
import { GetBookings } from './GetBookings';
import { Booking } from '../../../../models/bookings/Booking';
import { AmenitiesService } from '../../../../models/amenities/AmenitiesService';
import { SessionStorage } from '../../../../models/session/SessionStorage';
import { GetPublicBookings } from './GetPublicBookings';

export class GetPublicBookingsHandler implements QueryHandler<GetPublicBookings, Booking[]> {
    constructor(private amenitiesService: AmenitiesService) {}

    async handle(query: GetPublicBookings): Promise<Booking[]> {
        //ts-ignore
        return (this.amenitiesService as any).getPublicBookings(query.amenityId);
    }
}
